<link rel="ractive" href="../../r-docs.html" name="r-docs">
<link rel="ractive" href="../../components/header.html" name="c-gp-header">
<link rel="ractive" href="../../components/notification.html" name="c-notification">
<link rel="ractive" href="../../components/header-gradient.html" name="c-header-gradient">

<r-docs noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<style>
		{{#unless loaded}}
			[slot] {
				display: none;
			}
		{{/unless}}
	</style>

	<c-notification></c-notification>
	<c-gp-header additionalClasses="header-with-dark-bg header-fw-docs"></c-gp-header>

	{{#if screenWidth}}
		<rapi-doc
			spec-url="{{@shared.apiDocsHost}}/v1/spec.yaml"
			id="thedoc"
			theme="light"
			load-fonts="false"
			render-style="{{readStyle}}"
			regular-font="Lexend, sans-serif"
			mono-font="'Source Code Pro', monospace"
			show-header="false"
			allow-search="true"
			allow-advanced-search="false"
			allow-spec-url-load="false"
			allow-spec-file-load="false"
			allow-spec-file-download="true"
			allow-server-selection="false"
			allow-authentication="true"
			schema-description-expanded="true"
			schema-expand-level="1"
			match-type="includes"
			allow-schema-description-expand-toggle="false"
		>
		</rapi-doc>
	{{/if}}
</r-docs>

<script>
	const listeners = require('../../../assets/js/utils/listeners');

	component.exports = {
		data () {
			return {
				title: 'Globalping API',
				description: 'Use the Globalping API to access thousands of global probes and build your own tools and integrations.',
			};
		},
		computed: {
			readStyle () {
				return this.get('screenWidth') < 768 ? 'view' : 'read';
			},
		},
		onrender () {
			if (!Ractive.isServer) {
				this.set('screenWidth', window.innerWidth);

				listeners.screenWidthListener(this);

				this.find('rapi-doc').addEventListener('before-render', () => {
					this.set('loaded', true);
				});
			}
		},
	};
</script>
